
$(document).ready(function(){

    if (window.matchMedia("(max-width: 991px)").matches) {  

        var headerHeight = $('.logoNav').outerHeight();

        $('.js-toggleMenu').on('click',function(e){
            e.preventDefault();

            $(this).toggleClass('is-open');
            $('body').toggleClass('nav-expanded');
        });


        $('.anchorNav a').on('click',function(event){
            $('body').toggleClass('nav-expanded');
        });

        //Sottomenu
        $('.has-submenu>a').on('click',function(event){
            event.preventDefault();
            $(this).siblings('.submenu').slideToggle('slow');
            $(this).parent().toggleClass('is-selected');
        });

    }


    // Sottomenu desktop
    if (window.matchMedia("(min-width: 992px)").matches){

        $('.has-submenu > a').on('click', function(event){
            event.preventDefault();
             
            var selectedItem = $(this).parent('.has-submenu');

            if(!$(selectedItem).hasClass('is-selected')){
                $('.has-submenu').removeClass('is-selected').children('.submenu').removeClass('is-open');
                selectedItem.addClass('is-selected').children('.submenu').addClass('is-open');
            }
            
            else{
                selectedItem.removeClass('is-selected').children('.submenu').removeClass('is-open');
            }
        });
       
  
      $(document).click(function (e) {
        //check if the clicked area is dropDown or not
          if ($('.has-submenu').has(e.target).length === 0) {
                $('.has-submenu').removeClass('is-selected').children('.submenu').removeClass('is-open');
            }
          
          if ($('.js-dropdown,.js-dropdown > ul').has(e.target).length === 0) {
                $('.js-dropdown > ul').hide();
            }
           
        })
    }

    // Larghezza progress bar progetti landing 
    $("div[data-progress]").each(function(){
        $(this).css({
            width: $(this).attr('data-progress')
        });
    });

   

    // Slick 

    $('.carousel').slick({
        dots:true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: 'ondemand'
    });

    $('.carouselGuide').slick({
        dots:false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: 'ondemand'
    });

    $('.carouselReview').slick({
        dots:false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: 'ondemand',
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    arrows: true
                }
            }
        ],
      });

      $('.carouselThreeCols').slick({
        dots:false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: 'ondemand',
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    arrows: true
                }
            }
        ],
      });

 // TABS-ACCORDION

 var $titleTabs = $('.tabs-accordion .js-header');


 if (window.matchMedia("(max-width: 767px)").matches){


     $('.tabs-accordion .js-content').hide();
     $(".tabs-accordion .accordion__content[aria-labelledby='tab0']").show();


     $titleTabs.click(function () {
         $(this).next().slideToggle();
         $(this).toggleClass('active');
         $(this).parent().siblings().children().next().slideUp();
         $(this).parent().siblings().children().removeClass('active');
         return false;
     });


     $titleTabs.keydown(function(e){ // usare keydown e non keyup perché così si può sovrascrivere il comportamento di default della space-bar che se selezionata fa scrollare la pagina
         var keyCode = e.keyCode || e.which;

         if(keyCode == 13 || keyCode == 32){    // all'invio o alla space-bar
             $(this).next(copy).slideToggle();
             $(this).toggleClass('active');
             $(this).parent().siblings().children().next().slideUp();
             $(this).parent().siblings().children().removeClass('active');


             return false;
         }
     });
 }


 else if (window.matchMedia("(min-width: 768px)").matches){

     // Hide all but first tab content on larger viewports
     $('.tabs-accordion .js-content:not(:first)').css('display', 'none');

     // Activate first tab
     $(".tabs-accordion .accordion__header[aria-controls='panel0']");


     //var contentHeight = $('.accordion__item:first-child .accordion__header.active').next('.js-content').children('.blockTxtImg').outerHeight();  

     //var contentHeight = $('.accordion__content').outerHeight();                


     //$('.tabs-accordion').height(contentHeight); //  altezza header + padding testo

     $titleTabs.click(function () {                                      
         $(this).next().css('display', 'flex');
         $(this).parent().siblings().children().next().css('display', 'none');
         $(this).addClass('active');
         $(this).parent().siblings().children().removeClass('active');

         //var newContentHeight = $(this).next('.js-content').outerHeight();          
         //$('.tabs-accordion').height(newContentHeight ); //  altezza header

         return false;
     });


     $titleTabs.focus(function(e){

         $(this).next().css('display', 'flex');
         $(this).parent().siblings().children().next().css('display', 'none');
         $(this).addClass('active');
         $(this).parent().siblings().children().removeClass('active');
        
         /* var newContentHeight = $('.js-header.active').next('.js-content').children('.blockTxtImg').outerHeight();          
     $('.tabs-accordion').height(newContentHeight + 64);*/

         $(this).parent('.js-item').attr('aria-expanded','true').siblings().attr('aria-expanded','false');

     });

 } 


  //Accordion
  $('.accordion .accordion__item.accordion__content').show();

  var item = document.querySelectorAll('.accordion__item');
  for(var i = 0; i < item.length; i++) {
      item[i].classList.add('js-item');
  }

  var title = document.querySelectorAll('.accordion__header');
  for(var i = 0; i < title.length; i++) {
      title[i].classList.add('js-header');
  }

  var copy = document.querySelectorAll('.accordion__content');
  for(var i = 0; i < copy.length; i++) {
      copy[i].classList.add('js-content');
  }

  $('.accordion .js-content').slideUp();    
  $('.accordion__item .js-header').attr('aria-expanded','false');

  // Primo elemento aperto
  //$('.accordion .accordion__item:first-child .js-header').toggleClass('active');
  //$('.accordion .accordion__item:first-child .js-content').slideDown();
  //$('.accordion__item:first-child .js-header').attr('aria-expanded','true');


  //var $title = $('.accordion .js-header');

  $('.accordion .js-header').click(function () {
      $(this).next(copy).slideToggle();
      $(this).parent().siblings().children().next().slideUp();
      $(this).toggleClass('active');

      $(this).parent().siblings().children().removeClass('active');


      // toggle attributi
      if($(this).attr('aria-expanded') == 'true'){
          $(this).attr('aria-expanded','false');
      }

      else if($(this).attr('aria-expanded') == 'false'){
          $(this).attr('aria-expanded','true').siblings().attr('aria-expanded','false');
      }

      return false;

  });

  var $item = $('.accordion .js-item'); // per la tastiera ridefinisco il selettore perché è l'item ad essere focusable a differenza del clic del mouse cha va sull'header

  $item.keydown(function(e){ // usare keydown e non keyup perché così si può sovrascrivere il comportamento di default della space-bar che se selezionata fa scrollare la pagina

      var keyCode = e.keyCode || e.which;
      if(keyCode == 13 || keyCode == 32){    // all'invio o alla space-bar
          $(this).children(title).next(copy).slideToggle();
          $(this).siblings().children().next().slideUp();
          $(this).children(title).toggleClass('active');

          $(this).siblings().children().removeClass('active');


          if($(this).children(title).attr('aria-expanded') == 'true'){
              $(this).children(title).attr('aria-expanded','false');
          }

          else if($(this).children(title).attr('aria-expanded') == 'false'){
              $(this).children(title).attr('aria-expanded','true').siblings().attr('aria-expanded','false');
          }

          return false;
      }

  });

});

